var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.1877C16.5 21.1877 19 19.5627 19.5 19.3127C20 19.0627 20.5625 18.9377 20.875 19.1877C21.375 19.5002 25.5625 22.2502 25.9375 22.5002C26.3125 22.7502 26.4375 23.4377 26 24.1252C25.5 24.8127 23.3125 27.5627 22.375 27.5002C21.4375 27.5002 17.125 27.7502 9.68752 20.3752C2.25002 12.9377 2.50002 8.62518 2.50002 7.68768C2.50002 6.75018 5.18752 4.50018 5.87502 4.06268C6.56252 3.56268 7.25002 3.75018 7.50002 4.12518C7.75002 4.50018 10.5 8.68768 10.8125 9.18768C11 9.50018 10.9375 10.0627 10.6875 10.5627C10.4375 11.0627 8.81252 13.5627 8.81252 13.5627C8.81252 13.5627 9.25002 15.3127 11.9375 18.0627C14.6875 20.7502 16.5 21.1877 16.5 21.1877Z",
    fill: "#E9A306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 5.625H15.625V8.125H21.875C22.5625 8.125 23.125 8.6875 23.125 9.375V15.625H25.625V9.375C25.625 7.3125 23.9375 5.625 21.875 5.625Z",
    fill: "#F9D900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10L13.3125 6.875L17.5 3.75V10Z",
    fill: "#F9D900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBack);
export default __webpack_public_path__ + "static/media/CallBack.c91e1608bc03e65b6b56b6d5af8a64a0.svg";
export { ForwardRef as ReactComponent };